import { render, staticRenderFns } from "./EmployeePFStatementFront.vue?vue&type=template&id=834041f8"
import script from "./EmployeePFStatementFront.vue?vue&type=script&lang=js"
export * from "./EmployeePFStatementFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports